import React from 'react'
import { FilterNone } from '@material-ui/icons';
import { formatMoney } from '../lib/util';

export const TransactionColumnsBasic=({
    extra_actions
})=>{
    return [
        {
            title: "TXN TYPE",
            dataIndex: "type",
            key: "type",
            width: 53,
            render: (value, row, index) => {
                return <div title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}>
                    {value}
                </div>
            }
        }, {
            title: "TXN DATE",
            dataIndex: "txn_date",
            key: "txn_date",
            width: 100,
        }, {
            title: "TXN ID",
            dataIndex: "transaction_id",
            key: "transaction_id",
            width: 140,
        }, {
            title: "PARTICULARS ",
            dataIndex: "description",
            key: "description",
            className: 'word-break',
            render: (value, row, index) => {
                return <span>
                    {row.batch_id && <FilterNone
                        className='batch-indicator'
                        titleAccess="Batched"
                        style={{
                            marginRight: 8
                        }}
                    />}
                    {value}
                </span>
            }
        },
        {
            title: "AMOUNT",
            dataIndex: "amount",
            key: "amount",
            width: 100,
            render: (value, row, index) => formatMoney(value, 2, '.', ',')
        },
        ...extra_actions
    ];
}

